<template>
  <div>
    <v-dialog v-model="value" persistent max-width="60%">
      <v-card class="elevation-16 mx-auto">
        <v-card-title class="headline" primary-title>
          <span>{{ $t('event_log.history') }}</span>
        </v-card-title>

        <v-card-text>
          <v-data-table :headers="headers" :items="desserts" :search="search" class="elevation-1" hide-default-footer
                        :page.sync="page" :loading="loading" :items-per-page="itemsPerPage"
                        @page-count="pageCount = $event">
            <template v-slot:[`item.date`]="{ item }">
              <span class="text-no-wrap">{{ item.date | formateDate }}</span>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <span class="text-no-wrap">{{ getTextOfAction(item.action) }}</span>
            </template>

            <template v-slot:[`item.user`]="{ item }">
              <div class="contentAddress">
                <v-avatar size="30" class="mr-1">
                  <img v-if="item.user.avatar" :src="baseImage + item.user.avatar"/>
                  <img v-else src='@/assets/avatar_default.png'/>
                </v-avatar>

                <span class="text-no-wrap"> {{ item.user.fullname }} </span>
              </div>
            </template>

            <template v-slot:no-data>
              <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
          </v-data-table>

          <div class="text-center pt-2">
            <v-pagination v-model="page" :length="pageCount"></v-pagination>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="closeDialog">{{ $t('common.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
// import moment from 'moment';

export default {
  name: 'event-log',

  props: {
    value: Boolean,
    editedItem: Object,
    type: Number
  },


  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    loading: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 5,

    search: '',

    headers: [
      {text: '#', align: 'left', sortable: false, value: 'index',},
      {text: i18n.t('event_log.action'), sortable: false, value: 'action'},
      {text: i18n.t('event_log.date'), sortable: false, value: 'date'},
      {text: i18n.t('event_log.user'), sortable: false, value: 'user'}
    ],
    desserts: [],
  }),

  computed: {},

  watch: {},

  mounted() {

  },

  async created() {
    this.getLog(this.editedItem);
  },


  methods: {
    async getLog(item) {
      try {
        this.loading = true;

        var response = '';
        if (this.type === 1) {
          response = await this.$http.get('/requestLog/designRequest/' + item._id);
        } else {
          response = await this.$http.get('/requestLog/manufactureRequest/' + item._id);
        }
        this.loading = false;
        if (response.data && response.data.success) {
          this.desserts = response.data.data;
          this.desserts.forEach((item, index) => item.index = index + 1);
        }
      } catch (e) {
        console.log(e.stack);
      }
    },

    closeDialog() {
      this.$emit('closeDialog', false);
    },

    getTextOfAction(value) {//0: YCTK moi, 1: Change design, 2: YCSX moi, 3: YCSX edited, 4: YCSX hoan thanh,
      ///5: YC ship 6: ship success 7: Ship fail 8: TCKT da duyet, 9: Des da duyet
      switch (value) {
        case 0:
          return i18n.t('event_log.create_new');
        case 1:
          return i18n.t('event_log.change_des');
        case 2:
          return i18n.t('event_log.create_new');
        case 3:
          return i18n.t('event_log.edit');
        case 4:
          return i18n.t('event_log.finish');
        case 5:
          return i18n.t('event_log.create_ship');
        case 6:
          return i18n.t('event_log.ship_sucess');
        case 7:
          return i18n.t('event_log.ship_fail');
        case 8:
          return i18n.t('event_log.accountant_aprove');
        case 9:
          return i18n.t('event_log.des_approve');
        case 10:
          return i18n.t('event_log.des_uploaded');
        default:
          return '';
      }
    }
  }
}
</script>

<style scoped>
.v-text-field .v-input__control .v-input__slot {
  min-height: 45px !important;
  /* display: flex !important; */
  align-items: center !important;
}
</style>
